<template>
<div style="margin: 0 20px">
  <order-content :orderObj="orderObj" @closeOrder="closeOrder"></order-content>
  <div style="height: 30px"></div>
</div>
</template>
<script>
import orderContent from '../../servicemanagement/childComponents/orderContent.vue'
export default {
  name: 'detailsLog',
  model: {
    prop: 'detailsShow',
    event: 'change'
  },
  props: {
    detailsRow: {
      type: Object,
      default: null
    }
  },
  components: {orderContent},
  data () {
    return {
      orderObj: {
        row: '',
        type: 'log'
      }
    }
  },
  created () {
    // this.formData = this.detailsRow
    this.orderObj.row = this.detailsRow
  },
  mounted () {
  },
  methods: {
    closeOrder () {
      this.$emit('queryAlarmEvent')
      this.$emit('change')
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/statisticalform/childComponents/detailsLog.vue